import React from 'react';
import { Money } from 'components/utilities';
import { Organization, Federation } from 'resources';

class UnauthenticatedDonationConfirmation extends React.Component {

  state = {
    recipient: null,
  }

  componentDidMount() {
    this.doObjectRetrieve();
  }

  scope = () => (
    this.props.params.recipient === 'o' ? 'organization' : 'federation'
  )

  doObjectRetrieve = () => {
    const scope = this.scope() === 'organization' ? Organization : Federation;
    const { slug } = this.props.params;

    scope.lookup({
      data: { slug },
      onSuccess: ({ data }) => {
        this.setState({
          recipient: data,
        });
      },
    });
  }

  descriptionName = () => {
    const { recipient } = this.state;

    return (this.scope() === 'organization') ?
      `${_.get(recipient, 'federation.name')} at ${_.get(recipient, 'secondary')}` :
      `${_.get(recipient, 'name')}`;
  }

  descriptor = () => {
    const slug = this.recipientName()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-');

    return `Greek Capita*${slug}`.slice(0, 22);
  }

  recipientName = () => {
    const { recipient } = this.state;

    return (this.scope() === 'organization') ?
      _.get(recipient, 'federation.name') :
      _.get(recipient, 'name');
  }

  render = () => {
    const { recipient } = this.state;

    if (_.anyAreNil(recipient)) {
      return null;
    }

    const amount = +this.props.location.hash.slice(1);

    return (
      <div className="account-wrapper">
        <p className="account-wrapper m-t-2 m-b-neg-1"><br /></p>
        <div className="account-body m-t-2">

          <h3 className="text-success m-b-1">Thanks!</h3>

          <p className="m-b-2 fs-125">
            You{'\''}ve donated <Money amount={amount} /> to
            <br />
            {this.descriptionName()}
          </p>

          <p className="text-muted">
            The donation will appear as <em> {this.descriptor()} </em>
            <br />
            on your credit card statement.
          </p>

          <p className="m-t-2 m-b-2">
            We've sent you an email receipt of your donation.
          </p>

        </div>
      </div>
    );
  }

}

export default UnauthenticatedDonationConfirmation;
